import React from 'react'
import "./Header.css"

export default function Header(props) {
  return (
    <div className='header__container'>
      <div className='header__logo-holder'>
      <img className='header__logo' alt="logo" src={props.siteContent[0].company_logo} />
      </div>
    </div>
  )
}
